export let ANALYTICS_CONSTANTS = {
  // Global page - KEYS
  GLOBAL_PAGE_LOCATION_URL: 'page.location.url',
  GLOBAL_PAGE_FRIENDLY_PAGE_NAME: 'page.pageInfo.friendlyPageName',
  GLOBAL_PAGE_FLOW_CODE: 'page.pageInfo.flowCode',
  GLOBAL_PAGE_LANGUAGE: 'page.pageInfo.language',
  GLOBAL_PAGE_LINE_OF_BUSINESS: 'page.pageInfo.lineOfBusiness',
  GLOBAL_PAGE_RESPONSIVE_FLAG: 'page.pageInfo.responsiveWebDesignFlag',
  GLOBAL_PAGE_ZIP_CODE: 'page.pageInfo.zipCode',
  GLOBAL_PAGE_PAGE_FUNCTION: 'page.category.pageFunction',
  GLOBAL_PAGE_PAGE_OWNER_SHIP: 'page.category.pageOwnership',
  GLOBAL_PAGE_APP_NAME: 'page.category.applicationName',
  GLOBAL_PAGE_APP_CODE: 'page.pageInfo.appCode',
  GLOBAL_PAGE_SITE_SECTION: 'page.category.siteSection',
  GLOBAL_PAGE_SITE_SUB_SECTION: 'page.category.siteSubSection',
  GLOBAL_PAGE_SITE_SECTION1: 'page.category.siteSubSection1',
  GLOBAL_PAGE_SITE_SECTION2: 'page.category.siteSubSection2',
  GLOBAL_PAGE_ABS_CHECKOUT_STEP: 'page.attributes.ABScheckoutStepName',
  GLOBAL_PAGE_SKU: 'page.attributes.sku',
  GLOBAL_PAGE_PARENT_SKU: 'page.attributes.parentSku',
  GLOBAL_PAGE_VIEWED_UI_EXPERIENCE: 'page.pageInfo.viewedUIExperience',

  RESPONSIVEDESIGNFLAG_1: '1',
  RESPONSIVEDESIGNFLAG_0: '0',

  // Global page - VALUES
  BC_LANGUAGE_EN: 'EN',
  BC_LINE_OF_BUSINESS_VAL: 'General',
  BC_BUSINESS_VAL: 'Business',
  BC_APP_NAME_VAL: 'Business Console',
  BC_APP_CODE_VAL: 'BC',
  BC_SITE_SECTION: 'Marketplace',
  BC_DESKTOP: 'Desktop',
  BC_MOBILE: 'Mobile',

  // Global user - KEYS
  GLOBAL_USER_PRELOGIN_USER_ID: 'user.login.inputPreloginUserId',
  GLOBAL_USER_USER_ID: 'user.login.id',
  GLOBAL_USER_LOGIN_TYPE: 'user.login.type',
  GLOBAL_USER_LOGIN_SOURCE: 'user.login.loginSource',
  GLOBAL_USER_SERVICE_TYPE: 'user.account.serviceType',
  GLOBAL_USER_ACCOUNT_FOCUS_TYPE: 'user.account.accountInFocusType',
  GLOBAL_USER_CTN: 'user.account.ctn',
  GLOBAL_USER_BILLING_SYSTEM: 'user.account.billingSystem',
  GLOBAL_USER_BAN: 'user.account.ban',
  GLOBAL_USER_LIABILITY_TYPE: 'user.account.liabilityType',
  GLOBAL_USER_LIBERTY_FLAG: 'user.account.libertyFlag',
  GLOBAL_USER_APP_VISITOR_KEY: 'user.appVisitorCookie',
  GLOBAL_USER_TECH_LANGUAGE: 'user.tech.language',
  GLOBAL_USER_FAN: 'user.account.fan',
  GLOBAL_USER_WIRELESS_ACCOUNT_STATUS: 'user.account.wirelessAccountStatus',
  GLOBAL_USER_TECH_USER_AGENT: 'user.tech.userAgent',
  GLOBAL_USER_ABS_COMPANY_ROLE: 'user.attributes.ABScompanyRole',
  GLOBAL_USER_ABS_COMPANY_NAME: 'user.attributes.ABScompanyName',
  GLOBAL_USER_ABS_ACTOR_TYPE: 'user.attributes.ABSactorType',
  GLOBAL_USER_PREMIER_ENTERPRISE_TYPE: 'user.attributes.PremierEnterpriseType',
  GLOBAL_USER_REPRESENTATIVE_IPADDR: 'user.representativeIpAddress',
  GLOBAL_USER_MIMIC_ATTUID: 'user.attuid',
  GLOBAL_USER_MIMIC_PREMIER_AGREEMENT_NUMBER: 'user.attributes.PremierAgreementNumber',
  GLOBAL_USER_MIMIC_ALT_SEGMENT_TYPE: 'user.attributes.PremierAltSegmentType',
  GLOBAL_USER_MIMIC_PREMIER_ENTERPRISE_TYPE: 'user.attributes.PremierEnterpriseType',
  GLOBAL_USER_FIRSTNET_FLAG: 'user.attributes.firstNetFlag',
  GLOBAL_USER_FIRST_NET_USER_ROLE: 'user.attributes.firstNetUserRole',


  // Global user - VALUES
  BC_USER_BILLING_SYSTEM_VAL: 'T',
  BC_USER_LIABILITY_TYPE_VAL: 'Corporate',
  BC_USER_ABS_COMPANY_ROLE_VAL: 'CRU',
  BC_USER_LOGIN_TYPE: 'Individual User',
  BC_USER_SERVICE_TYPE: 'Wireless',
  BC_USER_ACCOUNT_FOCUS_TYPE: 'Wireless',

  // EVENTS

  EVENTS_SUCCESSFLAG: 'events.successFlag',
  EVENTS_ERRTYPE: 'events.errorType',
  EVENTS_STATUSMSG: 'events.statusMessage',
  EVENT_LINK_POSITION: 'linkPosition',
  EVENT_LINK_NAME: 'linkName',
  EVENT_LINK_DESTINATIONURL: 'linkDestinationUrl',
  EVENT_SUCCESS_FLAG: 'successFlag',
  EVENT_STATUS_CODE: 'statusCode',
  EVENT_EVENT_CODE: 'eventCode',
  EVENT_ITEMS: 'items',
  EVENT_STATUS_MESSAGE: 'statusMessage',
  EVENT_ERROR_TYPE: 'errorType',
  EVENT_FLOW_CODE: 'flowCode',
  /*EVENT_SUCCESS_FLAG: 'events[0].successFlag',
  EVENT_STATUS_CODE: 'events[0].statusCode',
  EVENT_EVENT_CODE: 'events[0].eventCode',
  EVENT_ITEMS: 'events[0].items',
  EVENT_STATUS_MESSAGE: 'events[0].statusMessage',
  EVENT_ERROR_TYPE: 'events[0].errorType',
  EVENT_FLOW_CODE: 'events[0].flowCode',*/
  EVENT_TOTAL_LICENSES: 'totalLicenses',
  EVENT_ASSIGNED_LICENSES: 'assignedLicenses',
  EVENT_INCRESED_LICENSES: 'increasedLicenses',
  EVENT_DECREASED_LICENSES: 'decreasedLicenses',
  EVENT_ITEM_SKU: 'itemSku',
  EVENT_ATC_METHOD: 'addToCartMethod',
  EVENT_ITEM_QTY: 'itemQty',
  EVENT_PRICE_MONTHLY: 'priceMonthly',
  EVENT_PRICE_FIRST_BILL: 'priceFirstBill',
  EVENT_ORDER_ID: 'orderId',

  EVENTS_SUCCESSFLAG_1: '1',
  EVENTS_SUCCESSFLAG_0: '0',

  EVENT_ACTION: 'eventAction',
  EVENT_CODE: 'eventCode',

  DATA_SET: 'dataset',

  EVENT_CODE_VIEW_CART: 'BC_View_Cart',
  EVENT_NAME_REVIEW_ORDER_SUBMIT: 'BC_Review_Order_Submit',
  EVENT_CODE_ORDER_CONFIRMED: 'BC_System_Order_Confirmed',
  EVENT_CODE_INCREASE_LICENSE: 'BC_Increase_Licenses_Confirmed',
  EVENT_CODE_DECREASE_LICENSE: 'BC_Decrease_Licenses_Confirmed',
  EVENT_CODE_REMOVEALL_LICENSE: 'BC_Remove_Licenses_Confirmed',
  EVENT_CODE_BILLING_CHECKOUT: 'BC_Billing_Account_Checkout',
  EVENT_CODE_ASSIGN_LICENSES: 'BC_Assigned_Licenses',
  EVENT_CODE_ALERT_DISPLAY: 'Page_Alert_Display',
  EVENT_ERROR_SUCCESS_TYPE: 'Success_Admit',
  EVENT_ERROR_FAILURE_TYPE: 'Failure_User',
  EVENT_ERROR_FAILURE_TYPE_FAILURE_SYSTEM: 'Failure_System',
  EVENT_CODE_PRODUCTSPECIFICINFO_Checkout: 'BC_ProductSpecificInfo_Checkout',
  EVENT_CODE_BC_CART_ADD_SUBMIT: 'BC_Cart_Add_Submit',
  EVENT_ACTION_FORM_SUBMIT: 'FormSubmit',
  EVENT_ACTION_FORM_RESPONSE: 'FormResponse',

  FRIENDLY_NAME_SIGNUP_STARTDATEMODEL: 'BC Device Signup StartDate Learn More Modal Pg',
  FRIENDLY_NAME_SIGNUP_ACCOUNTSFAILURE: 'BC Device Signup Processing Failure Modal Pg',
  FRIENDLY_NAME_SIGNUP_SETTINGSMODAL : 'BC Device Signup Support Modal Pg',
  FRIENDLY_NAME_SIGNUP_COFIRMREQUESTMODAL: 'BC Device Signup Confirm Request Modal Pg',
  FRIENDLY_NAME_SIGNUP_APPLICATIONSMODAL: 'BC Device Signup Applications Modal Pg',
  FRIENDLY_NAME_APPLECERTIFICATE_REMOVEMODAL: 'BC Device Apple Certificate Remove Modal Pg',
  FRIENDLY_NAME_APPLECERTIFICATE_INFO: 'BC Device Apple Certification Info Pg',
  FRIENDLY_NAME_APPLECERTIFICATE_UPLOAD: 'BC Device Apple Certificate Upload File Pg',
  FRIENDLY_NAME_CANCELPARTICIPATION_SELECTFAN: 'BC Device Cancel Participation Selection Fan Pg',
  FRIENDLY_NAME_CANCELPARTICIPATION_REVIEW: 'BC Device Cancel Participation Review Pg',
  FRIENDLY_NAME_CANCELPARTICIPATION_CONFIRM: 'BC Device Cancel Participation Confirmation Pg',
  FRIENDLY_NAME_INCREASE_LICENSE: 'BC Manage Product Add License Pg',
  FRIENDLY_NAME_DECREASE_LICENSE: 'BC Manage Product Decrease License Pg',
  FRIENDLY_NAME_USER_SUMMARY: 'BC User Summary Pg',
  FRIENDLY_NAME_USER_EDIT: 'BC User Edit Pg',
  FRIENDLY_NAME_CONTACT: 'BC Device Contact Pg',
  FRIENDLY_NAME_SINGLE_PRODUCT: 'BC Manage Product Pg',
  FRIENDLY_NAME_MANAGE: 'BC Manage Pg',
  FRIENDLY_NAME_MANAGE_USER_ACTION: 'BC Manage Users Action Pg',
  FRIENDLY_NAME_MANAGE_USER_USERS: 'BC Manage Users Users Pg',
  FRIENDLY_NAME_MANAGE_USER_PRODUCTS: 'BC Manage Users Products Pg',
  FRIENDLY_NAME_MANAGE_USER_REVIEW: 'BC Manage Users Review Pg',
  FRIENDLY_NAME_MANAGE_USER_CONFIRM: 'BC Manage Users Confirmation Pg',
  FRIENDLY_NAME_MANAGE_CANCEL: 'BC Manage Product Cancel Pg',
  FRIENDLY_NAME_CHANGE_PRODUCT: 'BC Change Product Pg',
  FRIENDLY_NAME_DASHBOARD: 'BC Device Dashboard Pg',
  FRIENDLY_NAME_HOME: 'BC Home Pg',
  FRIENDLY_NAME_BROWSE: 'BC Browse Pg',
  FRIENDLY_NAME_DETAILS: 'BC Product Details Pg',
  FRIENDLY_NAME_PRODUCT_CONFIGURATOR: 'BC Product Configurator Pg',
  FRIENDLY_NAME_CART: 'BC Cart Pg',
  FRIENDLY_NAME_BILLING_PAYMENT: 'BC Checkout Step 1 Billing Pmt Pg',
  FRIENDLY_NAME_CHECKOUT_STEP2: 'BC Checkout Step 2 Service Configuration Pg',
  FRIENDLY_NAME_CHECKOUT_STEP3: 'BC Checkout Step 3 Review Order Pg',
  FRIENDLY_NAME_CHECKOUT_STEP4: 'BC Checkout Confirm Order Pg',
  FRIENDLY_NAME_BULKUPLOAD_STEP1: 'BC Bulk User Upload Action Pg',
  FRIENDLY_NAME_BULKUPLOAD_STEP2: 'BC Bulk User Upload Pg',
  FRIENDLY_NAME_BULKUPLOAD_STEP3: 'BC Bulk User Upload Review Pg',
  FRIENDLY_NAME_BULKUPLOAD_STEP4: 'BC Bulk User Upload Confirm Pg',
  FRIENDLY_NAME_SIGNUP_SETTINGS: 'BC Device Signup Settings Pg',
  FRIENDLY_NAME_SIGNUP_ACCOUNTS: 'BC Device Signup Accounts Pg',
  FRIENDLY_NAME_SIGNUP_APPLICATIONS: 'BC Device Signup Applications Pg',
  FRIENDLY_NAME_SIGNUP_STARTDATE: 'BC Device Signup Startdate Pg',
  FRIENDLY_NAME_SIGNUP_REVIEW: 'BC Device Signup Review Pg',
  FRIENDLY_NAME_SIGNUP_CONFIRM: 'BC Device Signup Confirm Pg',
  FRIENDLY_NAME_MANAGE_INVENTORY: 'BC Device Manage Inventory Pg',
  FRIENDLY_NAME_CTN_INFO: 'BC Device Manage Ctn Info Pg',
  FRIENDLY_NAME_WIPEDEVICE: 'BC Device Wipe Device Modal Pg',
  FRIENDLY_NAME_LOCKDEVICE: 'BC Device Lock Device Modal Pg',
  FRIENDLY_NAME_FAN_DEPLOYMENT: 'BC Device Manage Profile FAN  Pg',
  FRIENDLY_NAME_DEVICE_INVENTORY: 'BC Device Manage Device Inventory Fan Pg',
  FRIENDLY_NAME_SUPPORT: 'BC Device Support Home Pg',
  FRIENDLY_NAME_FAQ: 'BC Device Support FAQs Pg',
  FRIENDLY_NAME_LEARN: 'BC Learn Pg',
  FRIENDLY_NAME_ELIGIBILITYMODAL: 'BC Device Eligibility Error Modal Pg',
  FRIENDLY_NAME_SMS_ACCOUNTS: 'BC Device Send Message Accounts Pg',
  FRIENDLY_NAME_SMS_MESSAGE: 'BC Device Send Message Pg ',
  FRIENDLY_NAME_SMS_REVIEW: 'BC Device Send Message Review Pg',
  FRIENDLY_NAME_SEND_MESSAGE_MODAL: 'BC Device Send Message Modal Pg',
  FRIENDLY_NAME_WELCOME: 'BC Device Welcome Pg',
  FRIENDLY_NAME_WELCOMEMODAL: 'BC Device Welcome Modal Pg',
  FRIENDLY_NAME_REQUEST_REPORTS_MODAL: 'BC Device Reports Request Modal Pg',
  FRIENDLY_NAME_REQUEST_REPORTS_REPORT_TYPE: 'BC Device Reports Transaction History Report Type Pg',
  FRIENDLY_NAME_REQUEST_REPORTS_DATE_RANGE: 'BC Device Reports Transaction History Date Range Pg',
  FRIENDLY_NAME_REQUEST_REPORTS_REVIEW: 'BC Device Reports Transaction History Review Pg',
  FRIENDLY_NAME_REQUEST_REPORTS_CONFIRMATION: 'BC Device Reports Transaction History Confirmation Pg',

  FLOW_CODE_MANAGE_DEVICE_MODAL: 'BC~DeviceTrack',
  FLOW_CODE_SEND_MESSAGE_MODAL: 'BC~DeviceTrack~SendMessage',
  FLOW_CODE_WELCOME: 'BC',
  FLOW_CODE_APPLECERTIFICATE: 'BC~DeviceTrack~AppleCertificate',
  FLOW_CODE_CANCELPARTICIPATION: 'BC~DeviceTrack~Cancel',
  FLOW_CODE_SHOP: 'BC~Shop',
  FLOW_CODE_CHECKOUT: 'BC~Checkout~SOC',
  FLOW_CODE_MANAGE_USERS: 'BC~ManageUsers',
  FLOW_CODE_MANAGE: 'BC~Manage',
  FLOW_CODE_UNK: 'BC~UNK',
  FLOW_CODE_LICENSE_MANAGEMNET_INCREASE: 'BC~LicenseManagement~Increase',
  FLOW_CODE_LICENSE_MANAGEMNET_DECREASE: 'BC~LicenseManagement~Decrease',
  FLOW_CODE_LICENSE_MANAGEMNET_REMOVE: 'BC~LicenseManagement~Remove',
   FLOW_CODE_CHANGE_PRODUCT : 'BC~ChangeProduct',
  FLOW_CODE_SIGNUP: ' BC~DeviceTrack~Signup ',
  FLOW_CODE_SMS: 'BC~DeviceTrack~SendMessage',
  FLOW_CODE_MANAGE_DEVICE: 'BC~DeviceTrack~Manage',
  FLOW_CODE_SUPPORT: 'BC~DeviceTrack~Support',
  FLOW_CODE_REPORTS: 'BC~DeviceTrack~Reports',
  FLOW_CODE_APPLE: 'BC~DeviceTrack~AppleCertificate',
  FLOW_CODE_DASHBOARD: 'BC~DeviceTrack~Dashboard',
    FLOW_CODE_LEARN: 'BC',
  FLOW_CODE_HOME: 'BC',

  GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE: 'Primary',
  ENVIRONMENT_URL: '/businessconsole',
  // Added device track constants to avoid compilation issue - This code needs to be removed after discussion with device track team.

  FRIENDLY_PAGE_URL_NAME: {
    '/home': 'BC Home Pg ',
    '/learn': 'BC Learn Pg',
    '/welcome': 'BC Welcome Pg',
    '/support': 'BC Support Pg',
    '/faq': 'BC Faq Pg',
    '/manageInventory': 'BC Manage Inventory Pg',
    '/dashboard': 'BC Dashboard Pg',
    '/ctnInfo': 'BC CtnInfo Pg',
    '/fanDeploymentProfile': 'BC Fan Deployment Profile Pg',
    '/signup/accounts': 'BC Signup Account Pg',
    '/signup/settings': 'BC Signup Settings Pg',
    '/signup/applications': 'BC Signup Applications Pg',
    '/signup/startdate': 'BC Signup Startdate Pg',
    '/signup/review': 'BC Signup Review Pg',
    '/signup/confirm': 'BC Signup Confirm Pg',
    '/signup-setup/enrollmentoptions': 'BC Signup-Setup Enrollment Options Pg',
    '/signup-setup/review': 'BC Signup-Setup Review Options Pg',
    '/signup-setup/confirm': 'BC Signup-Setup Confirm Options Pg',
    '/deviceInventory': 'BC Device Inventory Pg',
    '/cancelParticipation/selectfan': 'BC Cancel Participation Selectfan Pg',
    '/cancelParticipation/review': 'BC Cancel Participation Review Pg',
    '/cancelParticipation/confirm': 'BC Cancel Participation Confirm Pg',
    '/sendMessage/message': 'BC SendMessage Message Pg ',
    '/sendMessage/accounts': 'BC SendMessage Accounts Pg',
    '/sendMessage/review': 'BC SendMessage Review Pg',
    '/terms': 'BC Terms Pg',
    '/contact': 'BC Contact Pg',
    '/appleCertificate/info': 'BC AppleCertificate Info Pg',
    '/appleCertificate/upload': 'BC AppleCertificate Upload Pg',
    '/authentication': 'BC Authentication Pg',
    '/reports/transaction/reportType': 'BC Device Reports Transaction History Report Type Pg',
    '/reports/transaction/dateRange': 'BC Device Reports Transaction History Date Range Pg',
    '/reports/transaction/review': 'BC Device Reports Transaction History Review Pg',
    '/reports/transaction/confirmation': 'BC Device Reports Transaction History Confirmation Pg',
    '/virtual/reports/requestmodal.html': 'BC Device Reports Request Modal Pg',
    '/virtual/reports/request/confirmationmodal.html': 'BC Device Reports Request Confirmation Modal Pg',
    '/virtual/manageDevice/wipemodal.html': 'BC Device Wipe Device Modal Pg',
    '/virtual/manageDevice/lockmodal.html': 'BC Device Lock Device Modal Pg',

  },


  EVENT_ACTION_MATRIX:
  {
    'apple_id': 'BC_Device_Apple_Certificate_EnterID_Submit',
    'apple_upload_file': 'BC_Device_Apple_Certificate_UploadFile_Submit',
    'cancel_select_fan': 'BC_Device_Cancel_Select_FAN_Submit',
    'cancel_review_fan': 'BC_Device_Cancel_Review_FAN_Submit',
    'sms_select_account': 'BC_Device_SMS_Select_Account_Submit',
    'sms_select_fan_account': 'BC_Device_SMS_Select_FAN_Account_Submit',
    'device_sms_fan_account': 'BC_Device_SMS_Review_Submit',
    'device_initial_signup_submit': 'BC_Device_Initial_Signup_Submit',
    'device_enroll_submit': 'BC_Device_Enroll_Setup_Submit',
    'device_eligibility_submit': 'BC_Device_Check_Your_Eligiblity_Submit',
    'device_signup_continue_submit': 'BC_Device_Signup_Continue_Submit',
    'device_select_date_submit': 'BC_Device_Signup_Select_Date_Submit',
    'device_signup_review_submit': 'BC_Device_Signup_Review_Submit',
    'device_signup_profilename_submit': 'BC_Device_Signup_Profilename_Submit',
    'device_signupsetup_continue_submit': 'BC_Device_SignupSetup_Continue_Submit',
    'device_signupsetup_review_submit': 'BC_Device_SignupSetup_Review_Submit',
  }


};
